// extracted by mini-css-extract-plugin
module.exports = {"FaqPage":"styles_FaqPage__1q5hE","FaqList":"styles_FaqList__3mi_e","card":"styles_card__1ttrE","rowHeader":"styles_rowHeader__2o5t0","linkIcon":"styles_linkIcon__1O7i3"};